import { useAppDispatch, useAppSelector } from '../../store/store'
import './NetworkDropdown.css'
import { updateNetwork } from '../../store/network/NetworkActions'
import { Network, Networks } from '../../constants'
import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { requestSupportedBlockchainData } from 'src/store/stats/StatsActions'


const NetworkDropdown: React.FC = () => {
  const dispatch = useAppDispatch()
  const network = useAppSelector((state) => state.NetworkReducer.network)
  const [searchParams, setSearchParams] = useSearchParams()

  // Sync URL param -> Redux state on first load
  useEffect(() => {
    const urlNetwork = searchParams.get('net');

    if (urlNetwork && Networks.includes(urlNetwork as Network)) {
      if (network !== urlNetwork) {
        // Update Redux state first, saga will run after state updates
        dispatch(updateNetwork(urlNetwork as Network));
        return; // Exit early, wait for state to update before running saga
      }
    } else {
      searchParams.set('net', network);
      setSearchParams(searchParams, { replace: true });
    }

    // Safe to run saga when network is finalized
    dispatch(requestSupportedBlockchainData());
  }, [network, dispatch, searchParams, setSearchParams]);

  const handleChangeNetwork = (val: Network) => {
    dispatch(updateNetwork(val))
    dispatch(requestSupportedBlockchainData())
    searchParams.set('net', val)
    setSearchParams(searchParams, { replace: false }) // Push a new history entry
  }

  return (
    <select
      className="network-select"
      value={network}
      onChange={(event) => handleChangeNetwork(event.target.value as Network)}
    >
      {Networks.map((n) => (
        <option key={n} value={n}>
          {n.toLowerCase()}
        </option>
      ))}
    </select>
  )
}

export default NetworkDropdown
